/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from "react-redux";
import { Box, Grid, Skeleton, Typography, useMediaQuery, useTheme } from "@mui/material";
import { RootState, useAppDispatch } from "@store/store";
import { InactivityHandler } from "@components/InactivityHandler";
import { BOFU_TABS_CONFIG } from "@helpers/constantes";
import CustomRightImage from "@components/CustomRightImagev2";
import TabBofu from "@components/TabBofu/TabBofu";
import DocumentsTabBofu from "@components/TabBofu/DocumentsTabBofu";
import { setBofuTabDictamenDocument } from "@store/slices/bofuSlice";
import ButtonContinue from "@components/TabBofu/ButtonContinue";
import { CustomCompanyName } from "@components/CustomCompanyName";

const DocsEmpresa = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useAppDispatch();

  const bofuTabs = useSelector((state: RootState) => state.bofu.bofu_tabs_obj);
  const bufuLoading = useSelector((state: RootState) => state.bofu.isLoading);
  const companyRfc = useSelector((state: RootState) => state.register.company.rfc);

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8} mt={2}>
        <Box textAlign={"center"} mx={4}>
          <InactivityHandler />

          <CustomCompanyName />

          <TabBofu />

          {bufuLoading ? (
            <Box mt={4}>
              <Skeleton variant="rectangular" height={100} sx={{ borderRadius: 2 }} />
            </Box>
          ) : (
            <Box mt={4}>
              <Typography
                variant={isMobileOrTablet ? "body2" : "body1"}
                fontWeight={400}
                color={theme?.palette?.primary?.main}
              >
                Comenzaremos con el dictamen de tu empresa, para lo que necesitaremos los siguientes documentos
              </Typography>

              <Box mt={4}>
                <DocumentsTabBofu
                  tabCode={BOFU_TABS_CONFIG.tab_dictamen.code}
                  documents={bofuTabs?.dictamen?.documents || []}
                  onChange={({ document, newValue }) => {
                    dispatch(
                      setBofuTabDictamenDocument({ document, newValue, valueAction: undefined, valueIndex: undefined }),
                    );
                  }}
                  onChangeMultiple={({ document, newValue, valueAction, valueIndex }) => {
                    dispatch(setBofuTabDictamenDocument({ document, newValue, valueAction, valueIndex }));
                  }}
                  RFC={companyRfc}
                />
              </Box>

              <Box mt={4}>
                <ButtonContinue tabCode={BOFU_TABS_CONFIG.tab_dictamen.code} isFirstTab={true} />
              </Box>
            </Box>
          )}
        </Box>
      </Grid>
      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default DocsEmpresa;
